import React from "react";
import { DataTable } from "primereact/datatable";

const Tables = ({ children, rowData }) => {
  return (
    <DataTable
      value={rowData}
      paginator
      rows={10}
      showGridlines
      stripedRows
      className="p-datatable-sm"
      tableStyle={{
        minWidth: "50rem",
        border: "1px solid #ddd",
        borderRadius: "8px",
      }}
    >
      {children}
    </DataTable>
  );
};

export default Tables;
